import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not yet converted to GTS }}\n{{outlet}}\n",{ moduleName: "garaje/pods/property/settings/tenants/template.hbs" })